export enum DeliveryMethod {
  Collect = "2",
  Ship = "3",
}